import React, { Component } from 'react';
import classnames from 'classnames';
import Video from '../Assets/Video';
import Youtube from '../Assets/Youtube';
import Description from '../Assets/Description';
import './Project.css';

export default class Project extends Component {

  constructor(props) {
    super(props);
    // redux action, set default state for project.
    this.state = {
      classNames: classnames({
        "djs-project": true,
        "djs-project--selected": false
      }),
      project: this.props.project
    }

    this.styles = {
      backgroundImage: `url('${this.props.project.background}')`
    }
  }

  componentDidMount() {
    this.getProjectData(this.props.project.id);
  }

  componentWillReceiveProps(nextProps) {
    let projectProps = { ...nextProps }

    // redux action, set project
    this.setState({
      classNames: classnames({
        "djs-project": true,
        "djs-project--selected": projectProps.project.selected
      }),
      project: projectProps.project
    });

    this.getProjectData(projectProps.project.id);
  }

  getProjectData(projectId) {
    if (!this.state.project.selected || !!this.state.project.assets) return;

    // trigger redux action, set project loading to true.
    this.setState({ loading: true });

    fetch(`https://animated-rope-363.firebaseio.com/assets/${projectId}.json`).then((data) => data.json()).then((assets) => {
      this.setState({ loading: false });
      // trigger redux action, set project loading to false.

      if( assets === null ) return;
      if( assets.constructor !== Array || assets.length === 0 ) return;

      // trigger redux action, set current project to project props.
      this.setState((prevState, props) => {
        let state = [...prevState];

        state.project = props.project;
        state.project.assets = assets;

        return state;
      });
    });
  }

  select(e) {
    this.props.selectProject(this.props.project.id);
    this.getProjectData(this.props.project.id);
  }

  renderAssets() {
    let assets = this.state.project.assets ? [...this.state.project.assets] : [];

    if (!this.state.project.selected) {
      return '';
    }

    if (this.state.loading) {
      return <div className="djs-project__text-asset"><div className="djs-project_loading">Loading...</div></div>
    }

    if (assets.length === 0) {
      return <div className="djs-project__text-asset">Unfortunately there aren't any assets for this project yet.</div>
    }

    assets.sort((asset1, asset2) => asset1.order && asset2.order ? asset1.order - asset2.order : -1);

    assets = assets.map((asset, index) => {
      let assetMarkup;
      switch (asset.type) {
        case "secret":
          assetMarkup = <Description key={`${this.state.project.id}_${asset.type}_${index}`} description={asset.description} secret={this.state.project.secret && !this.props.revealSecrets} />
          break;
        case "text":
          assetMarkup = <Description key={`${this.state.project.id}_${asset.type}_${index}`} description={asset.description} />;
          break;
        case "richtext":
          if ( (asset.secret === false && this.props.revealSecrets) || (asset.secret && !this.props.revealSecrets) || asset.secret === undefined) {
            assetMarkup = <Description key={`${this.state.project.id}_${asset.type}_${index}`} description={asset.description} isRichText={true} />;
          }
          break;
        case "youtube":
          assetMarkup = this.state.project.secret && !this.props.revealSecrets ? '' : <Youtube key={`${this.state.project.id}_${asset.type}_${index}`} video={asset.video} title={this.state.project.id} width={asset.width} height={asset.height}/>;
          break;
        case "video":
          assetMarkup = this.state.project.secret && !this.props.revealSecrets ? '' : <Video key={`${this.state.project.id}_${asset.type}_${index}`} asset={asset}/>;
          break;
        case "image":
          assetMarkup = <img key={`${this.state.project.id}_${asset.type}_${index}`} className="djs-project__media-asset" src={asset.source} alt={asset.description} />
          if (this.state.project.secret && !this.props.revealSecrets) {
            assetMarkup = <div className="djs-project__secret" key={`${this.state.project.id}_secret_${asset.type}_${index}`}>{assetMarkup}</div>;
          }
          break;
        default:
          assetMarkup = '';
      }

      return assetMarkup;
    })

    return <div className="djs-project__text-asset">{assets}</div>;
  }

  getProjectName() {
    let projectName = this.state.project.name;

    if (this.state.project.secret && !this.props.revealSecrets) {
      if (projectName.secret) {
        projectName = projectName.secret;
      } else {
        projectName = '🔒 '+projectName.split('').map((value) => {
          if (value === ' ') return value;
          return "▓";
        }).join('');
      }
    }

    return projectName.text || projectName;
  }

  render() {
    return (
      <div
        className={this.state.classNames}
        key={this.state.project.id}
        selected={this.state.project.selected}
        tabIndex={this.state.project.index}
        onFocus={this.select.bind(this)}
        style={this.styles}
      >
        {this.state.project.secret && !this.props.revealSecrets ? <div style={{
          ...this.styles, position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, filter: 'blur(5px)', backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}></div>: null}
        <header className="djs-project__header">
          <h3 className="djs-project__h3">{this.getProjectName()}</h3>
          <i className="djs-project__close material-icons" onClick={this.props.close}>close</i>
        </header>
        <div className="djs-project__assets">
          {this.renderAssets()}
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/Project/Project.js